module.exports = __webpack_public_path__ + "images/backgrounds/city/small.27e00a7bee7a783ae756.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/city/small.jpg
// module id = zQ8p
// module chunks = 1